export {
    default as Progress,
    IProgressProps,
    TProgressColor,
} from './progress';
